import React, { useState, useEffect} from "react";
import { Layout, Button, Card, Form, Input, Select, Tooltip } from "element-react";
import { useHistory } from "react-router-dom";
import { Country, State } from 'country-state-city';
import WizardLeftMenu from "./wizardLeftMenu";
import tooltopImage from "../../assets/imgs/tooltip.png"

const normalizeStateForEdit = (rawState) => {
    if (!rawState) return "";
    
    // Limpieza: minúsculas, quitar comillas, paréntesis y puntos
    let clean = rawState.toString().toLowerCase()
        .replace(/["().]/g, "") 
        .trim();

    if (['nl', 'nuevo leon', 'nuevo león'].includes(clean)) return 'Nuevo León';
    if (['cdmx', 'ciudad de mexico', 'ciudad de méxico', 'df', 'distrito federal', 'la magdalena contreras'].includes(clean)) return 'Ciudad de México';
    if (['edomex', 'estado de mexico', 'estado de méxico', 'estado', 'mexico', 'méxico', 'mx', 'mex'].includes(clean)) return 'Estado de México';
    if (['guanajuato', 'guanjuato', 'gto'].includes(clean)) return 'Guanajuato';
    if (['pue', 'puebla', 'puebla mx'].includes(clean)) return 'Puebla';
    if (['jal', 'jalisco'].includes(clean)) return 'Jalisco';
    if (['chih', 'chihuahua'].includes(clean)) return 'Chihuahua';
    if (['coah', 'coahuila'].includes(clean)) return 'Coahuila';
    if (['durango'].includes(clean)) return 'Durango'; // Por si viene "DURANGO" en mayúsculas
    if (['qro', 'queretaro', 'querétaro'].includes(clean)) return 'Querétaro';
    if (['slp', 'san luis potosi', 'san luis potosí'].includes(clean)) return 'San Luis Potosí';
    if (['sonora', 'son'].includes(clean)) return 'Sonora';
    if (['veracruz', 'ver'].includes(clean)) return 'Veracruz';
    if (['morelos', 'mor'].includes(clean)) return 'Morelos';

    return clean.replace(/\b\w/g, l => l.toUpperCase());
};

export default function WizardNgStep0({ 
    handleNextStep, handlePrevStep, step, formInputs, setFormInputs, t, form0, rules0, type, yearOptions, revenue,
    idenfityDescriptionLanguage
  }) {

const [countriesList, setCountriesList] = useState([]);
  const [statesList, setStatesList] = useState([]);

  // 1. CARGAR PAÍSES (LIMITADO A MX, US, CA)
  useEffect(() => {
    const allCountries = Country.getAllCountries();
    const tMecCountries = allCountries.filter(c => ['MX', 'US', 'CA'].includes(c.isoCode));
    setCountriesList(tMecCountries);
  }, []);

  // 2. EFECTO : Cargar estados al detectar país
  useEffect(() => {
    if (formInputs.country) {
      const allCountries = Country.getAllCountries(); 
      const countryObj = allCountries.find(c => c.name.toLowerCase() === formInputs.country.toLowerCase());
      
      if (countryObj) {
        // Cargar estados
        const countryStates = State.getStatesOfCountry(countryObj.isoCode);
        setStatesList(countryStates);
      } else {
        setStatesList([]);
      }
    }
  }, [formInputs.country]);

  // 3. EFECTO "AUTO-CORRECTOR":
  useEffect(() => {
    if (formInputs.state && statesList.length > 0) {
        
        const exactMatch = statesList.find(s => s.name === formInputs.state);
        
        if (!exactMatch) {
            console.log("Estado antiguo detectado, reparando:", formInputs.state);
            
            const dbStateClean = normalizeStateForEdit(formInputs.state).toLowerCase();
            
            const foundState = statesList.find(s => {
                const listStateClean = s.name.toLowerCase();
                return listStateClean === dbStateClean || listStateClean.includes(dbStateClean);
            });

            if (foundState) {
                console.log(`Reparado: "${formInputs.state}" -> "${foundState.name}"`);
                setFormInputs(prev => ({ ...prev, state: foundState.name }));
            }
        }
    }
  }, [statesList]); 

  const handleCountryChange = (val) => {
    setFormInputs({ ...formInputs, country: val, state: '' });
    setTimeout(() => { form0.current.validateField('country'); }, 0);
  };

  return (
    <Layout.Row>
      <WizardLeftMenu step={step} />
      <Layout.Col xs="23" sm="23" md="20" lg="20">
        <Card className="box-card">
          <div className='create-store-title'>
            <h1>2. Company Information</h1>
          </div>
          <Form ref={form0} model={formInputs} className="en-US mt-2" rules={rules0} label-position="top">

            <div className="create-company-step0">
              <Layout.Row type="flex">
                <Layout.Col xs="24" sm="8" md="12" lg="8">
                  <Form.Item label={t('my-store.create.form.name')} prop="name">
                    <Tooltip placement="top" content="Share your legal Business Name" effect="light"><img className="tooltip-img" height={'20'} src={tooltopImage}></img></Tooltip>
                    <Input
                      maxlength={120}
                      value={formInputs.name}
                      onChange={(v) => { setFormInputs({ ...formInputs, name: v }) }}
                    />
               
                  </Form.Item>
                </Layout.Col>
                <Layout.Col xs="24" sm="8" md="12" lg="8">
                  <Form.Item label="Company Website" prop="website">
                  <Tooltip placement="top-start" content="This field is optional. It will help us to understand your services and buid a better strategy for your company" effect="light"><img className="tooltip-img" height={'20'} src={tooltopImage}></img></Tooltip>
                    <Input
                      maxlength={120}
                      value={formInputs.website}
                      onChange={(v) => { setFormInputs({ ...formInputs, website: v }) }}
                    />
                  </Form.Item>
                </Layout.Col>
              </Layout.Row>
              <Layout.Row>
                <Layout.Col xs="24" sm="24" md="24" lg="16">
                  <Form.Item label={t('my-store.create.form.description')} prop="description">
                  <Tooltip placement="top-left" content="Share a brief description of your business to let the buyers know what you do" effect="light"><img className="tooltip-img" height={'20'} src={tooltopImage}></img></Tooltip>
                    <Input className='description-field'
                      type="textarea"
                      value={formInputs.description}
                      onBlur={idenfityDescriptionLanguage}
                      placeholder={'Mention where and when your company was founded, your company experience, area of expertise and capabilities. Add any information that make your company stand out!'}
                      autosize={{ minRows: 53, maxRows: 5 }}
                      onChange={(v) => { setFormInputs({ ...formInputs, description: v }) }}
                    />
                  </Form.Item>
                </Layout.Col>
                <Layout.Col xs="24" sm="24" md="24" lg="8">
                  <div className='help-box'>
                    <h5>Need help? Here is a simple guideline:</h5>
                    <ul>
                      <li>What does your company do?</li>
                      <li>What’s your company experience?</li>
                      <li>Describe your company skills</li>
                      <li>Describe your equipment and infrastructure</li>
                      <li>What are your main products?</li>
                      <li>What’s your industry segment?</li>
                      <li>What makes your company different?</li>
                    </ul>
                  </div>
                </Layout.Col>
              </Layout.Row>
              <Layout.Row>
                <Layout.Col xs="24" sm="8" lg="8">
                  <Form.Item label={t('my-store.create.form.type')} prop="type">
                  <Tooltip placement="top-left" content="Please keep in mind that Bainub focused in physical products. If you provide manufacturing services, Bainub is for you" effect="light"><img className="tooltip-img" height={'20'} src={tooltopImage}></img></Tooltip>
                    <Select value={formInputs.type}
                      onChange={(v) => { setFormInputs({ ...formInputs, type: v }) }}
                    >
                      {
                        type.options.map(el => {
                          return <Select.Option key={el.value} label={el.label} value={el.value} />
                        })
                      }
                    </Select>
                  </Form.Item>
                </Layout.Col>
                <Layout.Col xs="24" sm="8" lg="8">
                  <Form.Item label={t('my-store.create.form.age')} prop="age">
                  <Tooltip placement="top-left" content="Year your company was founded" effect="light"><img className="tooltip-img" height={'20'} src={tooltopImage}></img></Tooltip>
                    <Select value={formInputs.age}
                      onChange={(v) => { setFormInputs({ ...formInputs, age: v }) }}
                    >
                      {
                        yearOptions.options?.map(el => {
                          return <Select.Option key={el.value} label={el.label} value={el.value} />
                        })
                      }
                    </Select>
                  </Form.Item>
                </Layout.Col>
                <Layout.Col xs="24" sm="8" lg="8">
                  <Form.Item label={t('my-store.create.form.anual_revenue')} prop="anual_revenue">
                  <Tooltip placement="top-left" content="This will help understand the size of your company" effect="light"><img className="tooltip-img" height={'20'} src={tooltopImage}></img></Tooltip>
                    <Select value={formInputs.anual_revenue}
                      onChange={(v) => { setFormInputs({ ...formInputs, anual_revenue: v }) }}
                    >
                      {
                        revenue.options?.map(el => {
                          return <Select.Option key={el.value} label={el.label} value={el.value} />
                        })
                      }
                    </Select>
                  </Form.Item>
                </Layout.Col>
              </Layout.Row>
              <Layout.Row type="flex">
                <Layout.Col xs="24" sm="24" lg="24">
                  <h4>Additional Information</h4>
                </Layout.Col>
              </Layout.Row>
              <Layout.Row type="flex">
                <Layout.Col xs="24" sm="24" lg="12">
                  <Form.Item label={t('How many people work at your company?')} prop="employees_qty">
                  <Tooltip placement="top-left" content="This field requires a numeric value" effect="light"><img className="tooltip-img" height={'20'} src={tooltopImage}></img></Tooltip>
                    <Input
                      value={formInputs.employees_qty}
                      onChange={(v) => { setFormInputs({ ...formInputs, employees_qty: v }) }}
                    />
                  </Form.Item>
                </Layout.Col>
                <Layout.Col xs="24" sm="24" lg="12">
                  <Form.Item label={t('my-store.create.form.production_lines_qty')} prop="production_lines_qty">
                  <Tooltip placement="top-left" content="This field requires a numeric value" effect="light"><img className="tooltip-img" height={'20'} src={tooltopImage}></img></Tooltip>
                    <Input
                      value={formInputs.production_lines_qty}
                      onChange={(v) => { setFormInputs({ ...formInputs, production_lines_qty: v }) }}
                    />
                  </Form.Item>
                </Layout.Col>
              </Layout.Row>
              <Layout.Row>
                <Layout.Col xs="24" sm="24" lg="12">
                  <label className="inline-block">If available, list three of your company certifications</label><Tooltip placement="top-left" className="inline-block ml-2" content="Examples: Quality, Environmental, Health and Safety. If you don't have any, please leave blank" effect="light"><img className="tooltip-img" height={'20'} src={tooltopImage}></img></Tooltip>
                  <Form.Item label={t('1')} prop="titles">
                    <Input
                      maxlength={30}
                      value={formInputs.titles}
                      onChange={(v) => { setFormInputs({ ...formInputs, titles: v }) }}
                    />
                  </Form.Item>
                  <Form.Item label={t('2')} prop="additional_titles1">
                    <Input
                      maxlength={30}
                      value={formInputs.additional_titles1}
                      onChange={(v) => { setFormInputs({ ...formInputs, additional_titles1: v }) }}
                    />
                  </Form.Item>
                  <Form.Item label={t('3')} prop="additional_titles2">
                    <Input
                      maxlength={30}
                      value={formInputs.additional_titles2}
                      onChange={(v) => { setFormInputs({ ...formInputs, additional_titles2: v }) }}
                    />
                  </Form.Item>
                </Layout.Col>
              </Layout.Row>
              <Layout.Row type="flex">
                <Layout.Col xs="24" sm="24" lg="24">
                  <h4>Company Address</h4>
                </Layout.Col>
              </Layout.Row>
              <Layout.Row className='address-box'>
                <Layout.Col xs="24" sm="24" lg="24">
                  <p> Your address will not be public. We might only display the country and state in your company profile.</p>
                </Layout.Col>
                <Layout.Row>
                  <Layout.Col xs="24" sm="24" lg="24">
                    <Form.Item label={t('Addres line 1')} prop="street">
                    <Tooltip placement="top-left" content="Primary Business Address: Where you manufanufacture or store your goods" effect="light"><img className="tooltip-img" height={'20'} src={tooltopImage}></img></Tooltip>
                      <Input
                        value={formInputs.street}
                        onChange={(v) => { setFormInputs({ ...formInputs, street: v }) }}
                      />
                    </Form.Item>
                  </Layout.Col>
                  <Layout.Col xs="24" sm="24" lg="16">
                    <Form.Item label={t('Address line 2')} prop="street2">
                      <Input
                        value={formInputs.street2}
                        onChange={(v) => { setFormInputs({ ...formInputs, street2: v }) }}
                      />
                    </Form.Item>
                  </Layout.Col>
                  {/* --- COUNTRY (SELECT) --- */}
                  <Layout.Col xs="24" sm="24" lg="8">
                    <Form.Item label={t('Country')} prop="country">
                      <Select 
                        value={formInputs.country} 
                        onChange={handleCountryChange}
                        placeholder="Select Country"
                        filterable={true} // Permite buscar escribiendo
                      >
                        {countriesList.map(c => (
                          <Select.Option key={c.isoCode} label={c.name} value={c.name} />
                        ))}
                      </Select>
                    </Form.Item>
                  </Layout.Col>

                  {/* --- STATE (SELECT) --- */}
                  <Layout.Col xs="24" sm="24" lg="8">
                    <Form.Item label={t('State')} prop="state">
                      <Select 
                        value={formInputs.state} 
                        onChange={(v) => {
                            setFormInputs(prev => ({...prev, state: v}));
                            setTimeout(() => {
                                if(form0.current) {
                                    form0.current.validateField('state');
                                }
                            }, 0);
                        }}
                        placeholder="Select State"
                        disabled={statesList.length === 0} 
                        filterable={true}
                        noDataText="Select country first"
                      >
                        {statesList.map(s => (
                          <Select.Option key={s.isoCode} label={s.name} value={s.name} />
                        ))}
                      </Select>
                    </Form.Item>
                  </Layout.Col>
                  <Layout.Col xs="24" sm="24" lg="8">
                    <Form.Item label={t('my-store.create.form.city')} prop="city">
                      <Input
                        value={formInputs.city}
                        onChange={(v) => { setFormInputs({ ...formInputs, city: v }) }}
                      />
                    </Form.Item>
                  </Layout.Col>
                  <Layout.Col xs="24" sm="24" lg="8">
                    <Form.Item label={t('my-store.create.form.zipCode')} prop="zipCode">
                      <Input
                        value={formInputs.zipCode}
                        onChange={(v) => { setFormInputs({ ...formInputs, zipCode: v }) }}
                      />
                    </Form.Item>
                  </Layout.Col>
                </Layout.Row>
              </Layout.Row>
              <Layout.Row>
                <Layout.Col className='mt-2'>
                  <Button type="secondary" onClick={handlePrevStep}>
                    Go back
                  </Button>
                  <Button type="primary" onClick={handleNextStep}>
                    {t('my-store.create.form.button-next')}
                  </Button>
                </Layout.Col>
              </Layout.Row>

              {
                /*
                    <Layout.Row type="flex">
                        <Layout.Col offset="1" xs="24" sm="24" lg="17">
                            <Form.Item label={t('my-store.create.form.address_str')} prop="address_str">
                                <Input 
                                    value={formInputs.address_str}
                                    onChange={(v) => {setFormInputs({...formInputs, address_str: v })}} 
                                    />
                            </Form.Item>
                        </Layout.Col>
                    </Layout.Row>
                */
              }

            </div>

          </Form>
        </Card>
      </Layout.Col>
    </Layout.Row>
  );
}